export enum TimeIntervalsActions {
  GetTimeIntervals = '[Pending] Get TimeIntervals',
  GetTimeIntervalsSuccess = '[Success] Get TimeIntervals',
  GetTimeIntervalsError = '[Error] Get TimeIntervals',
}
